import i18n from "./index";
import { isBinapsisBrand } from "../utils/utils";

/** Traducción usable fuera de componentes React (validaciones, utilidades). */
export function tr(key, defaultValue, options) {
  if (!isBinapsisBrand()) {
    if (options && typeof defaultValue === "string") {
      return defaultValue.replace(/\{\{(\w+)\}\}/g, (_, token) =>
        options[token] != null ? String(options[token]) : ""
      );
    }
    return defaultValue ?? key;
  }
  return i18n.t(key, { defaultValue, ...options });
}

export default tr;
